module.exports = __webpack_public_path__ + "static/fun-time/games/page002_game0/audio//M_Fantastic.mp3";